import { css } from '@linaria/core';
import theme from '../../../theme';

export const link = css`
  text-decoration: none;
  font-weight: 700;
  color: ${theme.colors.peoople['azul-claro-medio']};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
